<template>
<div>

    <!-- <headerNav title="我的订单" /> -->
    <navsearch placeholder="搜索收件人或收件号码" @onsearch="onsearch"></navsearch>
    <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">

                    <div v-for="(item,index) in navitem.orderList" :key="index">

                        <van-cell-group class="order-item" @click="godetail(item)">
                            <van-panel :title="'订单：'+item.tid" :status="item.orderStatusEnumName">
                                <div slot="header">
                                    <van-cell class="title" :title="'订单：'+item.tid" :value="item.splitOrderState==1?item.deliveryStatus==1?'部分发货':item.orderStatusEnumName:item.orderStatusEnumName" />
                                </div>
                                <div style="padding:8px 16px">
                                    <div><span>收件人:{{item.receiverName}}</span>     <span style="margin-left:5px">收件号码:{{item.receiverMobile}}</span></div>
                                    <div>收货地址:{{item.receiverState+" "+item.receiverCity+" "+item.receiverDistrict+" "+item.receiverCity+item.receiverAddress}}</div>
                                </div>
                                <div>
                                    <div>
                                        <div v-for="(product,i) in item.tradeDetails" :key="i">
                                            <trade-card :product='product' :isshowsend="(item.orderStatusEnum==1&&item.deliveryStatus!=0)||(item.orderStatusEnum==2&&item.buyerRefundStatus==0)"/>
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="total">总价：￥{{item.payment}}</div>
                                    <div v-if="item.orderStatusEnum==0">
                                        <van-button size="small" type="primary" :color="$abctheme.basecolor"  @click.stop="oncepay(item)">付款</van-button>
                                        <van-button size="small" type="primary" :color="$abctheme.basecolor" @click.stop="cancelOrder(item)">取消订单</van-button>
                                    </div>
                                    <div v-if="!systemsetting.isDisabledRefound &&  ((item.orderStatusEnum==2 && !systemsetting.isDisabledOrderReturn) || (item.orderStatusEnum==1&&item.buyerRefundStatus==0 && item.auditStatus==0 && item.tranferOrderState==0))">
                                        <van-button v-if="item.buyerRefundStatus==0" style="margin-bottom:10px;" :color="$abctheme.basecolor" size="small" type="primary" @click.stop="sqtk(item)">申请退款</van-button>
                                    </div>

                                    <van-button v-if="item.orderStatusEnum==2&&item.buyerRefundStatus==0&&item.deliveryStatus==2" size="small" :color="$abctheme.basecolor" type="primary" @click.stop="confirmsend(item)">确认收货</van-button>
                                        <!-- <van-button size="small" type="primary"  v-if="!systemsetting.isDisabledOrderReturn" @click.stop="sqtk(item)">申请退款</van-button> -->
                                    <van-button  v-if="item.orderStatusEnum==2 || item.deliveryStatus!=0" size="small" :color="$abctheme.basecolor" type="primary" @click.stop="logisticinfo(item)">快递轨迹</van-button>
                          
                                </div>
                            </van-panel>
                        </van-cell-group>

                    </div>

                </van-list>
            </van-tab>
        </van-pull-refresh>
    </van-tabs>

</div>
</template>

<script>
import request from "@/config/ajax";
export default {
    components: {},
    data() {
        return {
            isLoading: false,
            refreshing: false,
            tabCurrentIndex: 0,
            navList: [{
                    state: 0,
                    text: '全部',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "orderStateList": [],
                        "productSku": "",
                        "refundStatus": -1,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 1,
                    text: '待付款',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "orderStateList": [0],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 2,
                    text: '待发货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "orderStateList": [1],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 3,
                    text: '待收货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "orderStateList": [2],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 4,
                    text: '已签收',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "orderStateList": [3],
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                }
                // {
                //     state: 5,
                //     text: '退款',
                //     loadingType: 'more',
                //     loaded:false,
                //     getparams: {
                //         "tid": "",
                //         "name": "",
                //         "sku": "",
                //         "orderStateList": [1, 2],
                //         "productSku": "",
                //         "refundStatus": 1,
                //         "sorting": "",
                //         "maxResultCount": 10,
                //         "skipCount": 0
                //     },
                //     orderList: []
                // }
            ],
            systemsetting: undefined,
            paydto: {
                tid: ''
            }
        }
    },
    created() {

        request.post('/api/services/app/SystemSettingFunction/QueryModel').then(x => {
            this.systemsetting = x.result;
        })
        var option = this.$route.query;

        if (option.state) {
            this.tabCurrentIndex = Number.parseInt(option.state);
        }
        this.loadData();
    },
    methods: {
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        logisticinfo(item) {
            // this.$router.push({
            //     path: '/logistics',
            //     query: {
            //         tid: item.tid
            //     }
            // });
             this.$router.push({
                path: '/logisticstrajectory',
                query: {
                    tid: item.tid
                }
            });
        },
        onsearch(val){

            this.navList.forEach(x=>{
                x.getparams.nameOrPhone=val;
                x.loadingType='refresh';
            })
            this.loadData();
        },
        loadData(source) {
            //这里是将订单挂载到tab列表下
            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                if (source != "refresh") {
                    return;
                }
            }
            if(navItem.loadingType=='refresh')
            {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            if (source === 'refresh') {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            //加载数据
            request.post('/api/services/app/PhoneTrade/QueryOrder', params).then(x => {

                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].orderList = this.navList[index].orderList.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.navList[index].loaded = false;
                this.refreshing = false;
            });

        },
        godetail(item) {
            // console.log(item);
            this.$router.push({
                path: '/user/orderdetail',
                query: {
                    tid: item.tid
                }
            });
        },
        oncepay(item) {
            this.$router.push({
                path: '/pay',
                query: {
                    tid: item.tid,
                    code: ''
                }
            });
        },
        sqtk(item) {
            this.$dialog.confirm({title:'您是否要申请退款'}).then(x=>
            {
                 this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                })
                this.paydto.tid = item.tid;
                request.post('/api/services/app/PhoneRefund/BuyerRefund', this.paydto).then(() => {
                    this.loadData('refresh');
                })
            });
            
        },
        cancelOrder(item) {
            this.paydto.tid = item.tid;
            this.$dialog.confirm({title:'您是否要取消订单'}).then(x=>
            {
                request.post('/api/services/app/PhoneTrade/CancelOrder', this.paydto).then(() => {
                    //重新刷新或者替换该条数据
                    //查找两个列表将数据更换掉
                    this.loadData('refresh');
                })
            })
            
        },
        confirmsend(item) {
            this.paydto.tid = item.tid;
            request.post('/api/services/app/PhoneTrade/ConfirmReceiptOrder', this.paydto).then(() => {
                this.loadData('refresh');
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.order-item {
    font-size: 12px;
    margin: 10px 10px 10px 10px;
    box-shadow: 1px 1px 4px #d0d0d0;
}

.title {
    border-bottom: 1px solid #e5e5e5;
}

.van-cell__title {
    flex: 2;
}

.van-cell__value {
    color: red;
}

.van-panel__footer {
    text-align: right;
    border-bottom: 1px solid #e5e5e5;
}

.van-button {
    margin-left: 5px;
}

.total {
    font-size: 14px;
    text-align: left;
}

.more {
    overflow-x: scroll;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin: 5px 0 5px 15px;
}

.item {
    width: 90px;
    height: 90px;
    margin-right: 10px;
    display: inline-block;

}

.item img {
    width: 100%;
}
</style>
